module.exports = __webpack_public_path__ + "static/social-card-7f9fe12b5f051fdaf677eb584aaa0574.jpg";